import styled from 'styled-components'

const CameraStyle = styled.div`
    transition: var(--theme-change-transition);
    cursor: pointer;
    background-color: var(--main-bg-color);
    z-index: 2;
    & .camera_preview {
        transition: var(--theme-change-transition);
        padding: 20px 0px;
        box-shadow: var(--box-shadow);
        background-color: var(--main-bg-color);
        z-index: 2;
        position: relative;
    }
    & .camera_preview > * {
        margin: 0px 20px;
    }
    & .camera_desc_preview {
        transition: var(--theme-change-transition);
        padding: 20px;
        box-shadow: var(--box-shadow);
        background-color: var(--main-bg-color);
        margin-top: -5px;
    }
`

const CameraStatus = styled.div`
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background-color: ${props => props.ok ? "#00D969" : "#D90000"};
`

const CameraDesc = styled.div`
`

export {
    CameraStyle,
    CameraStatus,
    CameraDesc
}

